// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import { PRESUPUESTADOR_VALIDATE_SOLICITUD_PENDIENTE_PERITAJE } from './constants'
import { BFFAgent } from '../../../common/BFFAgent'

export function validateSolicitudPendiente(
  patente,
  verPeritaje,
  isCurrent,
  status
) {
  return async dispatch => {
    const solicitudPendiente = await BFFAgent.Peritador.getPeritaje(
      patente,
      verPeritaje,
      isCurrent,
      status
    )
    const checkSolicitudPendiente = solicitudPendiente.peritaje ? solicitudPendiente.peritaje.id : false
    const solicitudPendienteId = solicitudPendiente.peritaje?.id;
    dispatch({
      type: PRESUPUESTADOR_VALIDATE_SOLICITUD_PENDIENTE_PERITAJE,
      data: { solicitudPendiente: checkSolicitudPendiente, patente, solicitudPendienteId }
    })
  }
}

export function reducer(state, action) {
  if (action.type === PRESUPUESTADOR_VALIDATE_SOLICITUD_PENDIENTE_PERITAJE) {
      return {
        ...state,
        solicitudPendiente: { ...state.solicitudPendiente, [action.data.patente]: action.data.solicitudPendiente }
      }
  }
  else {
      return state
  }
}
